import { getChannelToken } from '@common-libs/tj-channel'
import pwaGlobalConfig from './pwaGlobalConfig'
import tjCookie from './tjCookie'

/**
 * 获取返回设备信息
 * @returns { promise } args string
 */
const getClientId = (cb) => {
  const { env } = pwaGlobalConfig
  try {
    if (env.isCtripApp) {
      window.cbridge?.CtripBusiness?.app_get_device_info?.((json) => {
        cb?.(json?.clientID)
      })
    } else if (env.isCtripMp) {
      cb?.(getChannelToken?.().cid)
    } else if (env.isQunarApp) {
      window.hysdk?.app?.getAppInfo?.({
        success: (data) => {
          cb?.(data?.gid)
        },
        fail: () => {
          cb?.('')
        }
      })
    } else if (env.isWechatMp) {
      cb?.(tjCookie?.getOpenId?.())
    } else if (env.isTujiaApp) {
      window?.tjBridge?.getAppInfo?.({
        success: (data) => {
          cb?.(data?.deviceId)
        },
        fail: (err) => {
          cb?.('')
        }
      })
    } else {
      cb('')
    }
  } catch (e) {
    cb?.('')
  }
}

const isHarmonyNext = () => {
  const { env } = pwaGlobalConfig
  const ua = window.navigator.userAgent.toLowerCase()
  let isHarmony = false

  try {
    if (env.isQunarApp && window.hysdk?.sniff) {
      const appVersion = window.hysdk && window.hysdk.sniff.appVersion
      const regex = /^5000\d{4}$/

      isHarmony = (appVersion >= 60001582 && appVersion <= 60001589) || regex.test(`${appVersion}`)
    }
    if (env.isCtripApp) {
      isHarmony = /_harmony_/.test(ua)
    }
  } catch (e) {
    return false
  }

  return isHarmony
}

export const isHarmony = isHarmonyNext()

export {
  getClientId
}
